import { useState, useEffect } from "react";
import { Drawer, Radio, Select } from "antd";
import { message } from "../../components/antdMessageBridge";
import { CloseCircleOutlined } from "@ant-design/icons";
import "../manifest_verificationqueue/verification-slider.css";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import CommonObj from "../../CommonObj";
import { useAuth } from "../../auth/AuthContext";
import DropdownArrow from "../../assets/img/svg/xdropdownarrow.svg?react";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import PropTypes from "prop-types";

const { Option } = Select;

const UserSliderUI = (props) => {
  console.log(props.selectedRecord);

  const [form, setForm] = useState({
    username: "",
    displayname: "",
    firstname: "",
    lastname: "",
    contactnumber: "",
    locationid: "",
    timeZoneId: "",
    roleId: "",
    email: "",
    status: "",
  });
  const [iform, setIForm] = useState({
    username: "",
    displayname: "",
    firstname: "",
    lastname: "",
    contactnumber: "",
    locationid: "",
    timeZoneId: "",
    roleId: "",
    email: "",
    status: "",
    domain: "",
  });
  const { roleUserId } = useAuth();
  const { accessToken} = useAuthToken();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [ierrors, setIErrors] = useState({});
  const [ntloginInput, setNtloginInput] = useState("");

  const [locationOptions, setLocationOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [timezoneOptions, setTimeZoneOptions] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedTimezone, setselectedtimezone] = useState("");
  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState();
  const [UserType, setUserType] = useState(null);

  const [selectedILocation, setSelectedILocation] = useState("");
  const [selectedITimezone, setselectedItimezone] = useState("");
  const [selectedIRole, setSelectedIRole] = useState([]);
  const [selectedIStatus, setSelectedIStatus] = useState("");
  const [error, setError] = useState(null);
  const [processingMode, setProcessingMode] = useState("internal");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      const firstErrorField = Object.keys(errors)[0];
      if (firstErrorField) {
        const element = document.getElementById(firstErrorField);
        if (element) element.focus();
      }
      return;
    }
    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
      };

      const requestData = {
        UserName: form.username,
        FirstName: form.firstname,
        LastName: form.lastname,
        DisplayName: form.displayname,
        ContactNo: form.contactnumber,
        Email: form.email,
        Location: selectedLocation,
        TimeZone: selectedTimezone,
        RoleIds: selectedRole?.join(","),
        IsActive: selectedStatus,
        UserType: UserType,
        CreatedBy: roleUserId || 1,
        ModifiedBy: roleUserId || 1,
        UserId: props.selectedRecord?.userId || 1,
      };

      let formData = new FormData();
      Object.keys(requestData).forEach(function (key) {
        formData.append(key, requestData[key]);
      });
      setLoading(true);

      const endpoint = props.selectedRecord
        ? CommonObj.Endpoints.UpdateUserDetails
        : CommonObj.Endpoints.CreateUserAsync;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: myHeaders,
        body: formData,
      });

      const result = await response.json();

      if (result.status) {
        message.success(
          props.selectedRecord
            ? "User updated successfully."
            : "User created successfully.",
        );

        handleClear();

        props.onClose();

        if (props.onSuccess) {
          props.onSuccess();
        }
      } else {
        message.error(result.message || "Failed to save the data");
      }
    } catch (error) {
      console.error("Error submitting form:", error.message);
      message.error("Error submitting form: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserData = async (userId) => {
    setLoading(true);
    const requestData = {
      UserId: userId, // Use existing userId if editing
    };

    let formData = new FormData();
    Object.keys(requestData).forEach(function (key) {
      formData.append(key, requestData[key]);
    });

    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
      };
      const response = await fetch(CommonObj.Endpoints.GetUserById, {
        method: "POST",
        headers: myHeaders,
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const responseText = await response.text();
      let result;

      try {
        result = JSON.parse(responseText);
        let roleIdsArray = [];
        if (result.roleIds) {
          if (typeof result.roleIds === "string") {
            roleIdsArray = result.roleIds
              .split(",")
              .map((id) => parseInt(id.trim()))
              .filter((id) => !isNaN(id));
          } else if (Array.isArray(result.roleIds)) {
            roleIdsArray = result.roleIds.map((id) => parseInt(id));
          } else {
            roleIdsArray = [parseInt(result.roleIds)];
          }
        }
        setForm({
          username: result.userName || "",
          displayname: result.displayName || "",
          firstname: result.firstName || "",
          lastname: result.lastName || "",
          contactnumber: result.contactNo || "",
          locationid: result.location || "",
          timeZoneId: result.timeZone || "",
          roleId: result.roleIds || "",
          email: result.email || "",
          status: result.isActive || "",
        });
        setIForm({
          username: result.userName || "",
          displayname: result.displayName || "",
          firstname: result.firstName || "",
          lastname: result.lastName || "",
          contactnumber: result.contactNo || "",
          locationid: result.location || "",
          timeZoneId: result.timeZone || "",
          roleId: result.roleIds || "",
          email: result.email || "",
          status: result.isActive || "",
          domain: result.domain || "",
        });
        setSelectedLocation(result.location || "");
        setselectedtimezone(result.timeZone || "");
        setSelectedRole(roleIdsArray || "");
        setSelectedStatus(result.isActive);
        setSelectedILocation(result.location || "");
        setselectedItimezone(result.timeZone || "");
        setSelectedIRole(roleIdsArray || "");
        setSelectedIStatus(result.isActive);

        if (result.userType) {
          setUserType(result.userType);
          setProcessingMode(result.userType === 2 ? "external" : "internal");
        }
      } catch (e) {
        if (responseText.includes("No books found.")) {
          result = [];
        } else {
          throw new Error(responseText || "Failed to parse API response.");
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!props.selectedRecord && props.visible) {
      setProcessingMode("internal");
      setUserType(1);
      setIForm({
        username: "",
        displayname: "",
        firstname: "",
        lastname: "",
        contactnumber: "",
        locationid: "",
        timeZoneId: "",
        roleId: "",
        email: "",
        status: "",
        domain: "AS",
        ntlogin: "",
      });
      setForm({
        username: "",
        displayname: "",
        firstname: "",
        lastname: "",
        contactnumber: "",
        locationid: "",
        timeZoneId: "",
        roleId: "",
        email: "",
        status: "",
      });
      setNtloginInput("");
      setSelectedLocation(undefined);
      setselectedtimezone(undefined);
      setselectedtimezone(undefined);
      setSelectedStatus(true);
      setSelectedILocation(undefined);
      setselectedItimezone(undefined);
      setSelectedIRole(undefined);
      setSelectedIStatus(true);
    }
  }, [props.visible, props.selectedRecord]);

  useEffect(() => {
    if (props.selectedRecord && props.visible) {
      fetchUserData(props?.selectedRecord.userId);
      fetchRoleData();
      fetchTimezoneData();
      fetchLocationData();
      if (props.selectedRecord.userType) {
        const userTypeValue = props.selectedRecord.userType === 2 ? 2 : 1;

        setUserType(userTypeValue);
        setProcessingMode(userTypeValue === 1 ? "internal" : "external");
        handleClear();
        handleIformClear();
      }
    }
  }, [props.selectedRecord, props.visible]);
  const handleInternalSubmit = async (e) => {
    e.preventDefault();

    if (!i_validate()) {
      focusFirstError();
      return;
    }

    setLoading(true);
    try {
      const response = await submitUserData();


      const result = await response.json();
      
      if (!response.ok) {
        const errorMessage = result.error || result.message || `Error ${response.status}`;
        throw new Error(errorMessage);
      }
      handleApiResponse(result);
    } catch (error) {
      message.error( error.message);
    } finally {
      setLoading(false);
    }
  };

  const focusFirstError = () => {
    const firstErrorField = Object.keys(ierrors)[0];
    if (firstErrorField) {
      const element = document.getElementById(firstErrorField);
      if (element) element.focus();
    }
  };

  const buildRequestData = () => ({
    UserName: iform.username,
    FirstName: iform.firstname,
    LastName: iform.lastname,
    DisplayName: iform.displayname,
    ContactNo: iform.contactnumber,
    Email: iform.email,
    Location: selectedILocation,
    TimeZone: selectedITimezone,
    RoleIds: selectedIRole?.join(","),
    IsActive: selectedIStatus,
    UserType: 1,
    CreatedBy: roleUserId,
    modifiedBy: roleUserId,
    UserId: props.selectedRecord?.userId || "1",
  });

  const submitUserData = async () => {
    const myHeaders = {
      Authorization: `Bearer ${accessToken}`,
      "X-CSRF-Token": encryptTimestamp(),
    };

    const requestData = buildRequestData();
    let formData = new FormData();
    Object.keys(requestData).forEach((key) => {
      formData.append(key, requestData[key]);
    });

    const endpoint = props.selectedRecord
      ? CommonObj.Endpoints.UpdateUserDetails
      : CommonObj.Endpoints.CreateUserAsync;

    return fetch(endpoint, {
      method: "POST",
      headers: myHeaders,
      body: formData,
    });
  };

  const handleApiResponse = (result) => {
    if (result.status) {
      const successMessage = props.selectedRecord
        ? "User updated successfully."
        : "User created successfully.";
      message.success(successMessage);

      handleClear();
      props.onClose();

      if (props.onSuccess) {
        props.onSuccess();
      }
    } else {
      const msg =
        result.message !== "" ? result.message : "Failed to save the data";
      message.error(msg);
    }
  };

  const fetchLocationData = async () => {
    setLoading(true);
    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
        "Content-Type": "application/json",
      };

      const response = await fetch(CommonObj.Endpoints.GetLocations, {
        method: "GET",
        headers: myHeaders,
      });

      if (response.ok) {
        const result = await response.json();
        const books = Array.isArray(result) ? result : [result];
        const formattedData = books.map((item) => ({
          ...item,
          key: item.referenceId,
        }));
        setLocationOptions(formattedData);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const fetchTimezoneData = async () => {
    setLoading(true);
    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
        "Content-Type": "application/json",
      };

      const response = await fetch(CommonObj.Endpoints.GetTimeZone, {
        method: "GET",
        headers: myHeaders,
      });
      if (response.ok) {
        const result = await response.json();
        const books = Array.isArray(result) ? result : [result];
        const formattedData = books.map((item) => ({
          ...item,
          key: item.referenceId,
        }));
        setTimeZoneOptions(formattedData);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const fetchRoleData = async () => {
    setLoading(true);
    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
        "Content-Type": "application/json",
      };
      const response = await fetch(CommonObj.Endpoints.GetRoles, {
        method: "GET",
        headers: myHeaders,
      });

      if (response.ok) {
        const result = await response.json();
        const books = Array.isArray(result) ? result : [result];
        const formattedData = books.map((item) => ({
          ...item,
          key: item.referenceId,
        }));
        setRoleOptions(formattedData);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const checkExistingUser = async (username) => {
    if (!username || !username.trim()) return false;

    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
      };

      const requestData = {
        UserName: username.trim(),
      };

      let formData = new FormData();
      Object.keys(requestData).forEach(function (key) {
        formData.append(key, requestData[key]);
      });

      const response = await fetch(CommonObj.Endpoints.ExistingUser, {
        method: "POST",
        headers: myHeaders,
        body: formData,
      });

      const result = await response.json();

      if (result.exists === true || result.exists === "true") {
        message.error("User already exists");

        if (processingMode === "internal") {
          setIForm((prev) => ({
            ...prev,
            ntlogin: "",
          }));
          setNtloginInput("");
        } else {
          setForm((prev) => ({
            ...prev,
            username: "",
          }));
        }

        return true;
      }

      return false;
    } catch (error) {
      message.error("Something went wrong!. Please contact your administrator");
      return true;
    }
  };
const isValidEmail = (email) => {
    if (!email || typeof email !== 'string' || email.length > 254) return false;
    const parts = email.split('@');
    if (parts.length !== 2) return false;
    const [local, domain] = parts;
    if (!local || !domain) return false;
    const domainParts = domain.split('.');
    if (domainParts.length < 2) return false;
    const tld = domainParts.at(-1); 
    if (tld.length < 2) return false;
    const hasWhitespace = /\s/.test(email);
    if (hasWhitespace) return false;
    return true;
};

  const checkExistingEmail = async (email) => {
    
    if (!email || !email.trim()) return;

    if (!isValidEmail(email)) {
        return;
    }

    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
      };

      const requestData = {
        Email: email.trim(),
      };

      let formData = new FormData();
      Object.keys(requestData).forEach(function (key) {
        formData.append(key, requestData[key]);
      });

      const response = await fetch(CommonObj.Endpoints.ExistingEmail, {
        method: "POST",
        headers: myHeaders,
        body: formData,
      });

      const result = await response.json();

      if (result.exists === true || result.exists === "true") {
        message.error("User already exists");
        if (processingMode === "internal") {
          setIForm((prev) => ({ ...prev, email: "" }));
        } else {
          setForm((prev) => ({ ...prev, email: "" }));
        }
        return false;
      }
      return true;
    } catch (error) {
      console.error("Error checking existing email:", error);
      return true;
    }
  };

  const handleUsernameBlur = (e) => {
    const username = e.target.value;
    if (username && !props.selectedRecord) {
      checkExistingUser(username);
    }
  };

  const handleEmailBlur = (e) => {
    const email = e.target.value;
    if (email && !props.selectedRecord) {
      checkExistingEmail(email);
    }
  };

  const handleClear = () => {
    setSelectedILocation(undefined);
    setselectedItimezone(undefined);
    setSelectedIRole([]);
    setSelectedIStatus(true);
    setUserType(null);
    setIErrors({});
    setIForm({
      username: "",
      displayname: "",
      firstname: "",
      lastname: "",
      contactnumber: "",
      locationid: "",
      timeZoneId: "",
      roleId: "",
      email: "",
      status: "",
      domain: "AS",
      ntlogin: "",
    });

    setNtloginInput("");
  };

  const handleIformClear = () => {
    setSelectedLocation(undefined);
    setselectedtimezone(undefined);
    setSelectedRole([]);
    setSelectedStatus(true);
    setUserType(null);

    setForm({
      username: "",
      displayname: "",
      firstname: "",
      lastname: "",
      contactnumber: "",
      locationid: "",
      timeZoneId: "",
      roleId: "",
      email: "",
      status: "",
    });

    setErrors({});
  };

  const validate = () => {
    const newErrors = {};

    if (!form.username?.trim()) {
      newErrors.username = "Please enter User name";
    }
    if (!form.displayname?.trim()) {
      newErrors.displayname = "Please enter Display name";
    }
    if (!form.firstname?.trim()) {
      newErrors.firstname = "Please enter First name";
    }
    if (!form.lastname?.trim()) {
      newErrors.lastname = "Please enter Last name";
    }
    if (!form.email?.trim()) {
      newErrors.email = "Please enter Email ID";
    } else if (!isValidEmail(form.email)) {
      newErrors.email = "Please enter a valid Email ID";
    }
    if (!selectedLocation) {
      newErrors.locationid = "Please select Location";
    }
    if (!selectedTimezone) {
      newErrors.timeZoneId = "Please select Timezone";
    }
    if (
      !selectedRole ||
      !Array.isArray(selectedRole) ||
      selectedRole.length === 0
    ) {
      newErrors.roleId = "Please select at least one Role";
    }
    if (
      selectedStatus === "" ||
      selectedStatus === null ||
      selectedStatus === undefined
    ) {
      newErrors.status = "Please select Status";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const i_validate = () => {
    const newErrors = {};

      if (!iform.username?.trim()) {
      newErrors.username = "Please enter NT Login ID";
    }
    if (!iform.displayname?.trim()) {
      newErrors.displayname = "Please enter Display name";
    }
    if (!iform.firstname?.trim()) {
      newErrors.firstname = "Please enter First name";
    }
    if (!iform.lastname?.trim()) {
      newErrors.lastname = "Please enter Last name";
    }
    if (!selectedILocation) {
      newErrors.locationid = "Please select Location";
    }
    if (!selectedITimezone) {
      newErrors.timeZoneId = "Please select Timezone";
    }
    if (
      !selectedIRole ||
      !Array.isArray(selectedIRole) ||
      selectedIRole.length === 0
    ) {
      newErrors.roleId = "Please select at least one Role";
    }
    if (
      selectedIStatus === "" ||
      selectedIStatus === null ||
      selectedIStatus === undefined
    ) {
      newErrors.status = "Please select Status";
    }

    setIErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleModeChange = (e) => {
    const selected = e.target.value;
    setProcessingMode(selected);
    setUserType(selected === "internal" ? 1 : 2);
    setSelectedRole(null);
    setIErrors({});
    setErrors({});
  };
  const handleBlur = async () => {
    if (!iform.ntlogin) return;
    const ntLoginRegex = /^[Rr]{2}\d{6}$/;
    if (!ntLoginRegex.test(iform.ntlogin)) {
      setIErrors((prev) => ({
        ...prev,
        ntlogin: "Invalid RRID format (should be rr123456)",
      }));
      message.error("Invalid RRID format");
      return;
    }

    setIErrors((prev) => ({
      ...prev,
      ntlogin: "",
    }));

    const userExists = await checkExistingUser(iform.ntlogin);

    if (userExists) {
      return;
    }
    Datagenerate(iform.ntlogin);
  };

  const handleIsbnInputChange = (e) => {
    const value = e.target.value?.trim();
    setNtloginInput(value);

    if (value.trim() === "") {
      setIForm({
        username: "",
        displayname: "",
        firstname: "",
        lastname: "",
        contactnumber: "",
        locationid: "",
        timeZoneId: "",
        roleId: "",
        email: "",
        status: "",
        domain: "",
      });
    } else {
        setIForm((prev) => ({ ...prev, ntlogin: value }));
        let name = "username";
        if (ierrors[name]) {
            setIErrors((prev) => ({ ...prev, [name]: "" }));
        }
    }
  };
  const handleIsbnKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (ntloginInput.trim() !== "") {
        populateFieldsByIsbn(ntloginInput);
      }
    }
  };
  const populateFieldsByIsbn = async (ntloginInput) => {
    setForm((prev) => ({
      ...prev,
      ntloginInput: ntloginInput,
    }));
    Datagenerate(ntloginInput);
  };
  async function Datagenerate(ntlogin, domain = null) {
    const effectiveDomain = domain || iform.domain || "AS";
    setLoading(true);
    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
      };

      const requestData = {
        UserName: ntlogin,
        Domain: effectiveDomain,
      };

      let formData = new FormData();
      Object.keys(requestData).forEach(function (key) {
        formData.append(key, requestData[key]);
      });

      const response = await fetch(
        CommonObj.Endpoints.GetUserDetailsByNTLoginId,
        {
          method: "POST",
          headers: myHeaders,
          body: formData,
        },
      );

      if (response.ok) {
        const result = await response.json();
        if (result) {
          setErrors({});
          setIForm({
            ...iform,
            username: String(result.userName || iform.username || ""),
            firstname: String(result?.firstName || ""),
            lastname: String(result?.lastName || ""),
            email: String(result?.email || ""),
            displayname: String(iform.displayname || ""),
            domain: effectiveDomain,
          });
        } else {
          message.warning("Invalid NT Login/Domain");
        }
      } else {
        message.error("Failed to retrieve user details");
      }
    } catch (error) {
      console.error(error.message);
      message.error("Invalid NT Login/Domain");
    } finally {
      setLoading(false);
    }
  }
  const handleDomainChange = async (e) => {
    const selectedDomain = e.target.value;

    setIForm((prev) => ({
      ...prev,
      domain: selectedDomain,
    }));

    if (iform.ntlogin && /^[Rr]{2}\d{6}$/.test(iform.ntlogin)) {
      await Datagenerate(iform.ntlogin, selectedDomain);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (name === "username") {
      if (!value.trim()) {
        setErrors((prev) => ({ ...prev, username: "Please enter User name" }));
      } else if (/\s/.test(value)) {
        setErrors((prev) => ({
          ...prev,
          username: "Username should not contain spaces",
        }));
      } else {
        setErrors((prev) => {
          const { username, ...rest } = prev;
          return rest;
        });
      }
    } else if (errors[name]) {
      setErrors((prev) => {
        const { [name]: removed, ...rest } = prev;
        return rest;
      });
    }
  };

  const handleInternalChange = (e) => {
    const { name, value } = e.target;
    setIForm((prev) => ({ ...prev, [name]: value }));
    if (ierrors[name]) {
      setIErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  useEffect(() => {
  const fieldsToWatch = ['firstname', 'lastname'];
  
  fieldsToWatch.forEach((fieldName) => {
    if (iform[fieldName] && ierrors[fieldName]) {
      setIErrors((prev) => ({
        ...prev,
        [fieldName]: "", 
      }));
    }
  });
}, [iform.firstname, iform.lastname]); 
  const handleLocationChange = (value) => {
    setSelectedLocation(value);

    if (errors.locationid && value) {
      setErrors((prev) => ({ ...prev, locationid: "" }));
    }
  };
  const handleTimezoneChange = (value) => {
    setselectedtimezone(value);

    if (errors.timeZoneId && value) {
      setErrors((prev) => ({ ...prev, timeZoneId: "" }));
    }
  };
  const handleRoleChange = (value) => {
    setSelectedRole(value);

    if (errors.roleId && value && value.length > 0) {
      setErrors((prev) => ({ ...prev, roleId: "" }));
    }

    if (selectedRole != null) {
      if (value.length === 0) {
        setSelectedRole(null);
      }
    }
  };
  const handlestatusChange = (e) => {
    setSelectedStatus(e.target.checked);
  };

  const handleILocationChange = (value) => {
    setSelectedILocation(value);
    if (ierrors.locationid && value) {
      setIErrors((prev) => ({ ...prev, locationid: "" }));
    }
  };
  const handleITimezoneChange = (value) => {
    setselectedItimezone(value);
    if (ierrors.timeZoneId && value) {
      setIErrors((prev) => ({ ...prev, timeZoneId: "" }));
    }
  };
  const handleIRoleChange = (value) => {
    setSelectedIRole(value);
    if (ierrors.roleId && value && value.length > 0) {
      setIErrors((prev) => ({ ...prev, roleId: "" }));
    }

    if (selectedIRole != undefined) {
      if (value.length === 0) {
        setSelectedIRole(undefined);
      }
    }
  };
  const handleIstatusChange = (e) => {
    setSelectedIStatus(e.target.checked);
  };

  useEffect(() => {
    if (props.selectedRecord) {
      message.info(props.selectedRecord);
    } else {
      fetchRoleData();
      fetchTimezoneData();
      fetchLocationData();
    }
    setIForm({
      username: "",
      displayname: "",
      firstname: "",
      lastname: "",
      contactnumber: "",
      locationid: "",
      timeZoneId: "",
      roleId: "",
      emailid: "",
      status: "",
      domain: "",
    });
  }, []);

  const handleNumericKeyDown = (event) => {
    if (["e", "E", "+", "-"].includes(event.key)) {
      event.preventDefault();
    }
  };
  const getInputClass = (value, baseClass = "book-page-form-input-text") => {
    return `${baseClass}${value ? " has-text" : ""}`;
  };
  const isEditMode = !!props.selectedRecord;
  const drawerTitle = isEditMode ? "Edit User" : props.title;

  const removeErrors = ()=>{
    handleClear()
    props.onClose()
  }
  return (
    <Drawer
      title={drawerTitle}
      placement={props.placement}
      onClose={removeErrors}
      open={props.visible}
      width={props.width}
      className={props.className}
      closeIcon={<CloseCircleOutlined />}
      loading={loading}
      destroyOnClose={true}
    >
      <div className="modal-body">
        <div className="">
          {!props.selectedRecord && (
            <div className="add-user-title-container">
              <div className="book-page-form-radio-container">
                <p className="book-page-form-radio-title">User</p>
                <div className="book-page-form-radio-button-container">
                  <Radio.Group
                    className="book-page-form-radio-button"
                    onChange={handleModeChange}
                    value={processingMode}
                  >
                    <Radio value="internal">Internal</Radio>
                    <Radio value="external">External</Radio>
                  </Radio.Group>
                </div>
              </div>
            </div>
          )}

          {processingMode === "internal" ? (
            <form
              className="book-page-form"
              onSubmit={handleInternalSubmit}
              noValidate
            >
              <div className="add-user-internal-container">
                {!props.selectedRecord && (
                  <div className="add-user-internal-input-2column">
                    <div className="field-group">
                      <input
                        placeholder=""
                        value={ntloginInput}
                        className={getInputClass(ntloginInput)}
                        maxLength={100}
                        onChange={handleIsbnInputChange}
                        onBlur={handleBlur}
                        onKeyPress={handleIsbnKeyPress}
                        required
                      />
                      <label htmlFor="ntlogin" className="label">
                        Enter NT Login ID{" "}
                        <span className="form-required">*</span>
                      </label>
                      {ierrors.username && (
                        <span className="error-msg">
                          {ierrors.username}
                        </span>
                      )}
                    </div>
                    <div className="field-group">
                      <select
                        name="domain"
                        id="domain"
                        className={`book-page-form-input-text has-text`}
                        value={iform.domain || "AS"}
                        onChange={handleDomainChange}
                      >
                        <option value=""></option>
                        <option value="NA">NA</option>
                        <option value="AS">AS</option>
                        <option value="EU">EU</option>
                        <option value="LA">LA</option>
                      </select>
                      <label htmlFor="domain">
                        Domain<span className="form-required">*</span>
                      </label>
                      {ierrors.domain && (
                        <span className="error-msg">{ierrors.domain}</span>
                      )}
                    </div>
                  </div>
                )}
                <div className="add-user-internal-table-contianer">
                  <table className="add-user-internal-table">
                    <tbody>
                      <tr>
                        <th scope="row">User Name</th>
                        <td className="td-value">
                          {String(iform.username || "")}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">First Name</th>
                        <td className="td-value">
                                        <div className="field-group" style={{marginLeft:"-14px"}}>
                  <input
                    id="firstname"
                    name="firstname"
                    placeholder="First Name"
                    className={getInputClass(iform.firstname)}
                    value={iform.firstname || ""}
                    maxLength={100}
                    onChange={(e) => {
                      const value = e.target.value;
                      const filteredValue = value.replace(/[0-9]/g, "");
                      handleInternalChange({
                        target: { name: "firstname", value: filteredValue },
                      });
                    }}
                    required
                  />

                  {ierrors.firstname && (
                    <span className="error-msg">{ierrors.firstname}</span>
                  )}
                </div>                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Last Name</th>
                        <td className="td-value">
                              <div className="field-group" style={{marginLeft:"-14px"}}>
                  <input
                    id="lastname"
                    name="lastname"
                     placeholder="Last Name"
                    className={getInputClass(iform.lastname)}
                    value={iform.lastname || ""}
                    maxLength={100}
                    onChange={(e) => {
                      const value = e.target.value;
                      const filteredValue = value.replace(/[0-9]/g, "");
                      handleInternalChange({
                        target: { name: "lastname", value: filteredValue },
                      });
                    }}
                    required
                  />
                  {ierrors.lastname && (
                    <span className="error-msg">{ierrors.lastname}</span>
                  )}
                </div>                
                        </td>
                      </tr>
                      <tr className="border-t">
                        <th scope="row">Email ID</th>
                        <td className="td-value">
                          {String(iform.email || "")}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="field-group" >
                  <input
                    id="displayname"
                    name="displayname"
                    className={getInputClass(iform?.displayname)}
                    maxLength={100}
                    value={iform.displayname || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      const filteredValue = value.replace(/[0-9]/g, "");
                      handleInternalChange({
                        target: { name: "displayname", value: filteredValue },
                      });
                    }}
                    required
                  />
                  <label htmlFor="displayname" className="label">
                    Display Name <span className="form-required">*</span>
                  </label>
                  {ierrors.displayname && (
                    <span className="error-msg">{ierrors.displayname}</span>
                  )}
                </div>
                <div className="field-group">
                  <input
                    id="contactnumber"
                    name="contactnumber"
                    type="number"
                    min="0"
                    onInput={(e) => {
                      if (e.target.value.length > 10) {
                        e.target.value = e.target.value.slice(0, 10);
                      }
                    }}
                    className={getInputClass(iform?.contactnumber)}
                    value={iform.contactnumber || ""}
                    onChange={handleInternalChange}
                    onKeyDown={handleNumericKeyDown}
                    required
                  />
                  <label htmlFor="contactnumber" className="label">
                    Contact Number
                  </label>
                  {ierrors.contactnumber && (
                    <span className="error-msg">{ierrors.contactnumber}</span>
                  )}
                </div>

                <div className="field-group">
                  <select
                    id="locationid"
                    name="locationid"
                    value={selectedILocation || ""}
                    onChange={(e) => handleILocationChange(e.target.value)}
                    className={getInputClass(selectedILocation)}
                  >
                    <option value=""></option>
                    {locationOptions.map((option) => (
                      <option key={option.locationId} value={option.locationId}>
                        {option.locationName}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="locationid" className="label">
                    Location <span className="form-required">*</span>
                  </label>

                  {ierrors.locationid && (
                    <span className="error-msg">{ierrors.locationid}</span>
                  )}
                </div>
                <div className="field-group">
                  <select
                    id="timeZoneId"
                    name="timeZoneId"
                    onChange={(e) => handleITimezoneChange(e.target.value)}
                    value={selectedITimezone || ""}
                    className={getInputClass(selectedITimezone)}
                  >
                    <option value=""></option>

                    {timezoneOptions.map((option) => (
                      <option key={option.timeZoneId} value={option.timeZoneId}>
                        {option.timeZone}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="locationid" className="label">
                    Central Standard Time{" "}
                    <span className="form-required">*</span>
                  </label>
                  {ierrors.timeZoneId && (
                    <span className="error-msg">{ierrors.timeZoneId}</span>
                  )}
                </div>
                <div className="field-group multiple-select-group">
                  <Select
                    id="roleId"
                    name="roleId"
                    mode="multiple"
                    // placeholder="Select Roles"
                    suffixIcon={<DropdownArrow />}
                    onChange={(value) => handleIRoleChange(value)}
                    value={selectedIRole}
                    className={getInputClass(selectedIRole)}
                    style={{ width: "100%" }}
                    showSearch
                    filterOption={(input, option) =>
                      option?.children
                        ?.toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {roleOptions.map((option) => (
                      <Option key={option.roleId} value={option.roleId}>
                        {option.roleName}
                      </Option>
                    ))}
                  </Select>
                  <label htmlFor="roleId" className="label">
                    Roles<span className="form-required">*</span>
                  </label>
                  {ierrors.roleId && (
                    <div
                      style={{
                        color: "#ff4d4f",
                        fontSize: "10px",
                        marginTop: "4px",
                        display: "block",
                      }}
                    >
                      {ierrors.roleId}
                    </div>
                  )}
                </div>

                <div>
                  <div>
                    <div className="book-page-form-checkbox-button">
                      <input
                        type="checkbox"
                        id="status"
                        name="status"
                        data-track="user-management-edit-is-active-toggle"
                        onChange={handleIstatusChange}
                        checked={selectedIStatus || ""}
                      />
                      <label htmlFor="used-condition-content">Is Active</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="modal-cancel-button" type="button" onClick={handleClear}>
                  Clear
                </button>
                <button className="accept-button" data-track="user-management-submit-user">Submit</button>
              </div>
            </form>
          ) : (
            <form className="book-page-form" onSubmit={handleSubmit} noValidate>
              <div className="add-user-external-container">
                <div className="field-group">
                  <input
                    id="username"
                    name="username"
                    className={getInputClass(form.username)}
                    value={form.username || ""}
                    onChange={handleChange}
                    onBlur={handleUsernameBlur}
                    disabled={props.selectedRecord ? true : false}
                    required
                    maxLength={100}
                  />
                  <label htmlFor="username" className="label">
                    User Name <span className="form-required">*</span>
                  </label>
                  {errors.username && (
                    <span className="error-msg">{errors.username}</span>
                  )}
                </div>
                <div className="field-group">
                  <input
                    id="displayname"
                    name="displayname"
                    className={getInputClass(form.displayname)}
                    maxLength={100}
                    value={form.displayname || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      const filteredValue = value.replace(/[0-9]/g, "");
                      handleChange({
                        target: { name: "displayname", value: filteredValue },
                      });
                    }}
                    required
                  />
                  <label htmlFor="displayname" className="label">
                    Display Name <span className="form-required">*</span>
                  </label>
                  {errors.displayname && (
                    <span className="error-msg">{errors.displayname}</span>
                  )}
                </div>
                <div className="field-group">
                  <input
                    id="firstname"
                    name="firstname"
                    className={getInputClass(form.firstname)}
                    value={form.firstname || ""}
                    maxLength={100}
                    onChange={(e) => {
                      const value = e.target.value;
                      const filteredValue = value.replace(/[0-9]/g, "");
                      handleChange({
                        target: { name: "firstname", value: filteredValue },
                      });
                    }}
                    required
                  />
                  <label htmlFor="firstname" className="label">
                    First Name <span className="form-required">*</span>
                  </label>
                  {errors.firstname && (
                    <span className="error-msg">{errors.firstname}</span>
                  )}
                </div>
                <div className="field-group">
                  <input
                    id="lastname"
                    name="lastname"
                    className={getInputClass(form.lastname)}
                    maxLength={100}
                    value={form.lastname || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      const filteredValue = value.replace(/[0-9]/g, "");
                      handleChange({
                        target: { name: "lastname", value: filteredValue },
                      });
                    }}
                    required
                  />
                  <label htmlFor="lastname" className="label">
                    Last Name <span className="form-required">*</span>
                  </label>
                  {errors.lastname && (
                    <span className="error-msg">{errors.lastname}</span>
                  )}
                </div>
                <div className="field-group">
                  <input
                    id="email"
                    name="email"
                    className={getInputClass(form.email)}
                    maxLength={50}
                    value={form.email || ""}
                    onBlur={handleEmailBlur}
                    disabled={props.selectedRecord ? true : false}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="emailid" className="label">
                    Email ID <span className="form-required">*</span>
                  </label>
                  {errors.email && (
                    <span className="error-msg">{errors.email}</span>
                  )}
                </div>
                <div className="field-group">
                  <input
                    id="contactnumber"
                    name="contactnumber"
                    className={getInputClass(form.contactnumber)}
                    type="number"
                    min="0"
                    onInput={(e) => {
                      if (e.target.value.length > 10) {
                        e.target.value = e.target.value.slice(0, 10);
                        form.contactnumber = e.target.value;
                      }
                    }}
                    value={form.contactnumber || ""}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="contactnumber" className="label">
                    Contact Number
                  </label>
                </div>
                <div className="field-group">
                  <select
                    id="locationid"
                    name="locationid"
                    onChange={(e) => handleLocationChange(e.target.value)}
                    value={selectedLocation || ""}
                    className={getInputClass(selectedLocation)}
                  >
                    <option value=""></option>

                    {locationOptions.map((option) => (
                      <option key={option.locationId} value={option.locationId}>
                        {option.locationName}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="locationid" className="label">
                    Location <span className="form-required">*</span>
                  </label>
                  {errors.locationid && (
                    <span className="error-msg">{errors.locationid}</span>
                  )}
                </div>
                <div className="field-group">
                  <select
                    id="timeZoneId"
                    name="timeZoneId"
                    placeholder="Select a timezone"
                    onChange={(e) => handleTimezoneChange(e.target.value)}
                    value={selectedTimezone || ""}
                    className={getInputClass(selectedTimezone)}
                  >
                    <option value=""></option>

                    {timezoneOptions.map((option) => (
                      <option key={option.timeZoneId} value={option.timeZoneId}>
                        {option.timeZone}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="locationid" className="label">
                    Enter Time <span className="form-required">*</span>
                  </label>

                  <span className="error-msg">{errors.timeZoneId}</span>
                </div>
                <div className="field-group multiple-select-group">
                  {console.log(selectedRole)}
                  <Select
                    id="roleId"
                    name="roleId"
                    mode="multiple"
                    suffixIcon={<DropdownArrow />}
                    // placeholder="Select Roles"
                    onChange={(value) => handleRoleChange(value)}
                    value={selectedRole}
                    className={getInputClass(selectedRole != null)}
                    style={{ width: "100%" }}
                    showSearch
                  >
                    {roleOptions.map((option) => (
                      <Option key={option.roleId} value={option.roleId}>
                        {option.roleName}
                      </Option>
                    ))}
                  </Select>
                  <label htmlFor="roleId" className="label">
                    Roles<span className="form-required">*</span>
                  </label>
                  {errors.roleId && (
                    <div
                      style={{
                        color: "#ff4d4f",
                        fontSize: "10px",
                        marginTop: "4px",
                        display: "block",
                      }}
                    >
                      {errors.roleId}
                    </div>
                  )}
                </div>

                <div>
                  <div className="book-page-form-checkbox-button">
                    <input
                      type="checkbox"
                      id="status"
                      name="status"
                      data-track="user-management-edit-is-active-toggle"
                      onChange={handlestatusChange}
                      checked={selectedStatus || undefined}
                    />
                    <label htmlFor="used-condition-content">Is Active</label>
                    <span className="error-msg">{errors.status}</span>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="modal-cancel-button"
                  type="button"
                  onClick={handleIformClear}
                >
                  Clear
                </button>
                <button className="accept-button" data-track="user-management-submit-user">Submit</button>
              </div>
            </form>
          )}
        </div>
      </div>
    </Drawer>
  );
};

UserSliderUI.propTypes = {
  selectedRecord: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string,
  placement: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

export default UserSliderUI;